import { Box, Grid } from '@mui/material';
import defaultStyles from '../../assets/styles/panelStyles';

type PanelProps = {
  headerText: React.ReactNode;
  children: React.ReactNode;
  styleClasses?: {
    panelHeader?: any;
    panelContent?: any;
  };
};

export default function Panel({
  headerText,
  children,
  styleClasses,
}: PanelProps) {
  const styles = styleClasses ?? defaultStyles;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box sx={styles.panelHeader}>{headerText}</Box>
      </Grid>

      <Grid item xs={12}>
        <Box sx={styles.panelContent}>{children}</Box>
      </Grid>

      <Grid item xs={12} paddingBottom={2} />
    </Grid>
  );
}
